<div class="page quality-policy">
	<div class="illustrated-item" id="entrada2">
		<div class="illustration"></div>
		<div class="content">
			<p class="title">Descarga PDF</p>
			<p>Presione el enlace para la descarga:</p>
			<p>
				<a class="inline" target="_blank" href="/assets/documents/quality-policy.pdf">Política de Calidad de APROMAR (PDF)</a>
			</p>
		</div>
	</div>
</div>